import React, { useMemo } from 'react'
import { useDeepMemo } from '../../../hooks/useDeepReactHooks.hooks'
import { GridHeaderGroupRow } from '../components/GridHeaderGroupRow'
import { type GridDatum, type CustomTableInstance } from './grid.types'

interface Props<TDatum extends GridDatum> extends CustomTableInstance<TDatum> {}

export const useGridWindowDetails = <TDatum extends GridDatum>({
  headerGroups,
  prepareRow,
  rows,
}: Props<TDatum>) => {
  /* 
    TODO: This useDeepMemo is stopping the headers from rerendering when the sort state changes. 
    ie: The sorting gets updated, but the sort indicator does not change. Need to understand the original
    issue being fixed before making a change here to ensure we don't have regressions

    Original PR: https://github.com/instacart/carrot/pull/312948/files#diff-187cdb23e55b701ee756e81f9f7a58e8b45f3a9d0ff91f59bc691585a71368f4
  */

  const renderedHeaders = useDeepMemo(
    () =>
      headerGroups.map((headerGroup, index) => <GridHeaderGroupRow key={index} {...headerGroup} />),
    [headerGroups]
  )

  const itemCount = rows.length

  const itemData = useMemo(
    () => ({
      rows: rows,
      prepareRow,
    }),
    [rows, prepareRow]
  )

  return {
    renderedHeaders,
    itemCount,
    itemData,
  }
}
